import { serverOrClient } from './server-or-client';
export const udUserAgnosticTrackingParams = () => {
  var _serverOrClient$globa;
  return (_serverOrClient$globa = serverOrClient.global.UD) === null || _serverOrClient$globa === void 0 ? void 0 : _serverOrClient$globa.userAgnosticTrackingParams;
};
//# sourceMappingURL=ud-user-agnostic-tracking-params.js.map